'use strict';
var fields = document.querySelectorAll('form input');
fields.forEach(function(item) {
    var label = document.createElement('label');
    label.className = 'field-label';
    label.setAttribute('for', item.id);
    label.textContent = item.name;
    var placeholder = item.name.toLowerCase();
    item.placeholder = placeholder[0].toUpperCase() + placeholder.slice(1);
    item.before(label);
});

//# sourceMappingURL=js_task_fix_form_DOM.b35edc7e.js.map
